<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
        label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="sprint项目" prop="sprid"><el-input disabled v-model="sprName"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行任务" prop="sbiId"><el-input disabled v-model="sprBLogName"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="类型">
              <el-select v-model="typed" placeholder="请选择">
                <el-option label="日志" value="0"></el-option>
                <!--el-option label="计划" value="1"></el-option-->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="typed == 0 ? false : true">
            <el-form-item label="计划完成工时" prop="jhHours">
              <el-input-number v-model="formParameter.jhHours" @change="handleChangeWchours"
                :placeholder="'最大值为' + this.parameter.hopegs + '小时'" autocomplete="off">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="typed == 0">
          <el-col :span="12">
            <el-form-item label="累积进度" prop="kfAdvance">
              {{ formParameter.kfAdvance ? (formParameter.kfAdvance * 100).toFixed(1) : 0 }}%
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成时间" prop="wkdate">
              <el-date-picker v-model="wkdate" value-format="yyyy-MM-dd" type="date"
                placeholder="选择计划完成时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="typed == 0">
          <el-col :span="5">
            <el-form-item label="完成工时" prop="wchours"><el-input v-model="wchours" @change="handleChangeWchours"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="7">
            累计完成 {{ (parameter.wchours * 1 || 0) + (wchours * 1 || 0) }}
            / 消耗 {{ (parameter.realgs * 1 || 0) + (realgs * 1 || 0) }} 工时
            <br>
            计划 {{ parameter.hopegs || 0 }} 工时
          </el-col>
          <el-col :span="12">
            <el-form-item label="消耗工时" prop="realgs"><el-input v-model="realgs"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="typed == 0">
            <el-form-item label="日志详情" prop="remark">
              <wang-edit :isupdt="isUpdtWedit" v-model="formParameter.remark"></wang-edit>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/sprint/devRecord/devRecord.js";
import apiSBL from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import { log } from "console";
export default {
  name: "edit",
  components: {
    popup,
    wangEdit
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {}, //Sprint待办列表
      formParameter: {}, //开发日志
      remark: "",
      jhHours: '',//计划完成工时
      plan: '',//计划文本
      wkdate: "",
      pmid: "", //成员id
      tmName: "", //成员名称
      sprid: "", //sprint的Id
      sprName: "", //sprint名称
      sbiId: "", //sprint代办id
      sprBLogName: "", //sprint代办名称
      typed: '0', //类型 0-日志，1-计划
      isUpdtWedit: false, //用于更新wangEdit
      wchours: 0,
      realgs: 0,
      isEditMode: false,
      originalId: ''

    };
  },
  // watch: {
  //   wchours(newVal) {
  //     const baseW = (this.parameter && this.parameter.wchours) ? this.parameter.wchours * 1 : 0;
  //          console.log("baseW=",baseW,"newVal=",newVal)
  //     const totalW = baseW + (newVal * 1 || 0);
  //     const hopegs = this.parameter && this.parameter.hopegs ? this.parameter.hopegs : 0;
  //     if (hopegs > 0) {
  //       console.log("totalW=",totalW,"hopegs=",hopegs)
  //       this.$set(this.formParameter, 'kfAdvance', (totalW / hopegs).toFixed(3));
  //     }
  //   },
  // },

  watch: {
    wchours() {
      this.updateKfAdvance();
    },
  },
  methods: {
    //打开弹框
    open(sblog, devRecord, title, disabled, size) {
      this.pmid = "";
      this.tmName = "";
      this.sprid = "";
      this.sprName = "";
      this.sbiId = "";
      this.sprBLogName = "";
      this.typed = '0';
      this.formParameter = {};
      this.wchours = 0,
        this.realgs = 0
      this.isEditMode = false;
      this.originalId = '';
   
      if (sblog) {
        //新增
        this.parameter = sblog;

        //默认
        this.wkdate = new Date();

        // 重置wangedit 残存的数据
        this.isUpdtWedit = true
        this.formParameter.remark = ''
        setTimeout(() => {
          this.isUpdtWedit = false
        }, 45)


        if (devRecord) {
          //添加同一个待办下的多条日志         
          // 2. 续加
          this.formParameter = devRecord;

          this.pmid = this.formParameter.pmid;
          this.tmName = this.formParameter.tmName;
          this.sprid = this.formParameter.sprid;
          this.sprName = this.formParameter.sprName;
          this.sbiId = this.formParameter.sbiId;
          this.sprBLogName = this.formParameter.sblName;
        }
        else {
          //添加待办下第一条开发记录所需数据     1. 新加
          this.pmid = this.parameter.pmid;
          this.tmName = this.parameter.tmName;
          this.sprid = this.parameter.sprid;
          this.sprName = this.parameter.sprName;
          this.sbiId = this.parameter.id;
          this.sprBLogName = this.parameter.name;
        }
      } else {
        //修改
        this.isEditMode = true;
        this.formParameter = devRecord;
        this.parameter = {
          wchours: this.formParameter.wchours || 0,
          realgs: this.formParameter.realgs || 0,
          hopegs: this.formParameter.hopegs || 0
        };

        this.originalId = this.formParameter.id || '';
        if (devRecord.wchours) {
          this.wchours = devRecord.wchours;
          //this.parameter.wchours = this.parameter.wchours - this.wchours
        } else {
          this.wchours = 0;
        }

        this.realgs = devRecord.realgs || 0;

        this.pmid = this.formParameter.pmid;
        this.tmName = this.formParameter.dbColumn_pmid;
        this.sprid = this.formParameter.sprid
        this.sprName = this.formParameter.sprName;
        this.sbiId = this.formParameter.sbiId;
        this.sprBLogName = this.formParameter.sblName;
        this.wkdate = this.formParameter.wkdate || new Date();
      }

      this.disabled = disabled;
      this.$refs.popup.open(title, size);

      // 扩展 init() 调用条件
      // 之前只在 formParameter.id 存在时才调 init()
      // 但 dev_record/list.vue 的 toUpdate 里 delete newRow.id 删掉了 id
      // 导致修改模式下 parameter 是空对象 {}, hopegs 拿不到, kfAdvance 算不出来
      // 现在只要有 id 或者是带 sbiId 的修改模式, 都调 init() 去拿待办完整数据
      if (this.formParameter.id || (this.isEditMode && this.formParameter.sbiId)) {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        // 先算好新累计(用于 kfAdvance)
        const baseW = (this.parameter && this.parameter.wchours) ? this.parameter.wchours * 1 : 0;
        const newCumW = baseW + (this.wchours * 1 || 0);

        // DevRecord 只存本次增量
        this.formParameter.wchours = this.wchours * 1 || 0;
        this.formParameter.realgs = this.realgs * 1 || 0;

        // 修改模式恢复原始 id
        if (this.isEditMode && this.originalId && !this.formParameter.id) {
          this.formParameter.id = this.originalId;
        }

        // 三层兜底补全关键字段，防止后端 NPE
        if (!this.formParameter.pmid) this.formParameter.pmid = this.pmid || this.parameter.pmid;
        if (!this.formParameter.sprid) this.formParameter.sprid = this.sprid || this.parameter.sprid;
        if (!this.formParameter.sbiId) this.formParameter.sbiId = this.sbiId || this.parameter.id;

        // 更新日期（编辑时 init 已经拿到原 wkdate，新增时用默认日期）
        this.formParameter.wkdate = this.wkdate;

        // 
        const hopegs = this.parameter && this.parameter.hopegs ? this.parameter.hopegs : 0;
        if (hopegs > 0) {
          this.formParameter.kfAdvance = (newCumW / hopegs).toFixed(3);
        }

        // 统一用完整 formParameter 提交
        let parameter = this.$utils.merger(this.formParameter);

        api.merge(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    handleChangeWchours(inputContent) {
      setTimeout(() => {
        const baseW = (this.parameter && this.parameter.wchours) ? this.parameter.wchours * 1 : 0;
        const totalW = baseW + (this.wchours * 1 || 0);
        const hopegs = this.parameter && this.parameter.hopegs ? this.parameter.hopegs : 0;
        if (hopegs > 0 && totalW > hopegs) {
          this.wchours = hopegs - baseW;
          this.$utils.msg.warning('本次完成工时超过剩余计划工时，已自动修正');
        }
      }, 10);
    },
    updateKfAdvance() {
      const baseW = (this.parameter && this.parameter.wchours) ? this.parameter.wchours * 1 : 0;
      console.log("baseW=", baseW, "wchours=", this.wchours);
      const totalW = baseW + (this.wchours * 1 || 0);
      const hopegs = this.parameter && this.parameter.hopegs ? this.parameter.hopegs : 0;
      if (hopegs > 0) {
        console.log("totalW=", totalW, "hopegs=", hopegs);
        this.$set(this.formParameter, 'kfAdvance', (totalW / hopegs).toFixed(3));
      }
    },


    init() {
      this.popupLoading = true;
      this.confirmLoading = false;
      this.parameter = {};
      this.$refs.form.clearValidate();

      // ========== 修复: init 分三种情况 ==========
      // 情况A: 有 DevRecord id → 查 DevRecord 完整数据, 再补查 SprintBacklog 拿 hopegs
      // 情况B: 没有 DevRecord id 但有 sbiId → 直接查 SprintBacklog(不能调 DevRecord 的 toUpdate, 后端 required id)
      // 情况C: 都没有 → 不调接口

      if (this.formParameter.id) {
        // ===== 情况A: 有 DevRecord id =====
        api.toUpdate({ id: this.formParameter.id }, (response) => {
          if (response.data) {
            // 1. 把完整数据存到 this.parameter
            this.parameter = response.data;

            // 2. 把完整数据合并回 formParameter(覆盖掉原来可能缺字段的 devRecord)
            this.formParameter = Object.assign({}, response.data, {
              id: response.data.id || this.formParameter.id
            });

            // 3. 把关键 ID 同步到 data 变量(confirm 里补全用得到)
            if (!this.sprid) this.sprid = this.formParameter.sprid;
            if (!this.sbiId) this.sbiId = this.formParameter.sbiId;
            if (!this.pmid) this.pmid = this.formParameter.pmid;

            // 4. wangEdit 和日期
            this.isUpdtWedit = true
            this.formParameter.remark = response.data.remark;
            setTimeout(() => {
              this.isUpdtWedit = false
            }, 45)
            this.wkdate = response.data.wkdate;

            // 5. ⭐ DevRecord 表里没有 hopegs(计划工时), 它在 SprintBacklog 表里
            //    这里再查一次 SprintBacklog 把 hopegs 补进来给 kfAdvance 计算用
            if (this.formParameter.sbiId) {
              apiSBL.toUpdate({ id: this.formParameter.sbiId }, (sblRes) => {
                if (sblRes.data) {
                  this.parameter.hopegs = sblRes.data.hopegs;
                }
              });
            }
          }
          this.popupLoading = false;
        });

      } else if (this.formParameter.sbiId) {
        // 情况B: 没有 DevRecord id, 但有 sbiId 
        // 从 dev_record/list.vue 进入编辑时 delete 了 newRow.id, 所以 formParameter.id 是 undefined
        // 不能调 DevRecord 的 toUpdate(后端 @RequestParam(required=true) 必填)
        // 直接根据 sbiId 查 SprintBacklog, 拿 hopegs(计划工时) 给 kfAdvance 计算用
        apiSBL.toUpdate({ id: this.formParameter.sbiId }, (response) => {
          if (response.data) {
            // 把 SprintBacklog 数据存到 this.parameter(主要是 hopegs)
            this.parameter = response.data;

            if(this.wchours>0){
               this.parameter.wchours = this.parameter.wchours - this.wchours
           
              //  this.wchours = this.wchours+1
              //  this.wchours = this.wchours-1
            }
            this.updateKfAdvance();

             if(this.realgs>0){
               this.parameter.realgs = this.parameter.realgs - this.realgs
            }

            // 同步关键 ID
            if (!this.sprid) this.sprid = response.data.sprid;
            if (!this.sbiId) this.sbiId = response.data.id;

            // DevRecord 的日期 formParameter 里已经有了, 没有就兜底
            this.wkdate = this.wkdate || response.data.wkdate;
          }
          this.popupLoading = false;
        });

      } else {
        // 情况C: 都没有, 什么都不做 
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>